<template>
  <v-row style="background-color: white" class="pl-2">
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <!-- <v-dialog v-model="dialogNotifyNotXeroSync" persistent max-width="500">
      <v-card tile flat color="white" v-if="quotation != null">
        <v-card-text class="pa-0">
          <v-row justify="center">
            <v-alert tile dense prominent type="info" class="body-1 py-4">
              Company
              <strong>{{ quotation.company.name }}</strong> is not synchronised with Xero.
            </v-alert>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row justify="end" class="py-2">
            <v-btn
              color="primary"
              class="font-weight-bold mx-2"
              tile
              depressed
              small
              @click="companySyncXero"
            >
              <v-icon size="20" class="mr-1">mdi-sync</v-icon>SYNC
            </v-btn>

            <v-btn
              color="error"
              class="font-weight-bold ml-2"
              tile
              depressed
              small
              @click="dialogNotifyNotXeroSync = false"
            >
              <v-icon size="20" class="mr-1">mdi-close</v-icon>CLOSE
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <v-dialog v-model="dialogSavedInvoice" persistent max-width="430">
      <v-card tile flat color="white">
        <v-card-text class="pa-0">
          <v-row justify="center">
            <v-alert tile dense type="success" class="body-1" min-width="430">
              Invoice&nbsp;
              <strong>{{ invoice_id }}</strong
              >&nbsp; was successfully created.
            </v-alert>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row justify="space-between">
            <v-btn
              color="secondary"
              class="font-weight-bold mr-4"
              depressed
              dark
              style="text-decoration: none"
              @click="goToInvoicePage"
              >GO TO INVOICES</v-btn
            >
            <v-btn
              color="primary"
              class="font-weight-bold ml-4"
              depressed
              dark
              @click="onReset"
              >CREATE NEW INVOICE</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row no-gutters>
      <v-col class="d-flex justify-start">
        <v-subheader class="headline primary--text">New Invoice</v-subheader>
      </v-col>

      <v-col cols="6" class="d-flex justify-center pt-3">
        <span class="primary--text subtitle-1">{{ getInvoiceTitle() }}</span>
      </v-col>

      <v-col></v-col>
    </v-row>

    <v-row no-gutters class="pl-2 pt-2" v-if="quotation != null">
      <v-col>
        <span class="font-weight-bold body-2 primary--text">
          To:
          <v-chip
            label
            small
            outlined
            color="primary"
            class="caption font-weight-bold text-uppercase px-1"
            >{{ quotation.company.name }}</v-chip
          >
        </span>
      </v-col>

      <v-col class="d-flex justify-center">
        <span class="font-weight-bold body-2 primary--text">
          Currency:
          <v-chip
            label
            small
            outlined
            color="primary"
            class="caption font-weight-bold px-1"
            >{{ quotation.currency }}</v-chip
          >
        </span>
      </v-col>

      <v-col class="d-flex justify-end">
        <span class="font-weight-bold body-2 primary--text">
          By:
          <v-chip
            label
            small
            outlined
            color="primary"
            class="caption font-weight-bold mx-1"
            >{{ $root.useraccount.email }}</v-chip
          >
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-divider></v-divider>
    </v-row>

    <v-row no-gutters class="pl-2 pb-3 pt-2">
      <v-col cols="5" class="d-flex justify-start">
        <v-menu open-on-hover right offset-x>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              tile
              small
              color="primary"
              class="font-weight-bold mr-3"
            >
              GENERATE NEW INVOICE
              <v-icon right dark>mdi-menu-down</v-icon>
            </v-btn>
          </template>

          <v-list class="py-0">
            <v-list-item
              dense
              class="py-1"
              v-for="(item, index) in generateInvoiceBtnItems"
              :key="index"
              @click="generateNewInvoice(item)"
            >
              <v-list-item-title
                class="caption text-uppercase font-weight-bold primary--text"
                >{{ item.title }}</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>

      <v-col cols="3" class="d-flex justify-content-center">
        <span class="headline black--text">{{ invoice_title }}</span>
      </v-col>

      <v-col v-if="$root.is_admin" class="d-flex justify-content-end">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              class="font-weight-bold"
              small
              text
              color="error"
              @click="onReset"
            >
              <v-icon class="mr-1">mdi-restart</v-icon>RESET
            </v-btn>
          </template>
          Reset invoice to initialise state
        </v-tooltip>
      </v-col>
    </v-row>

    <v-row no-gutters class="px-2 mb-4" v-if="quotation != null">
      <v-col style="background-color: #2196f3" class="pa-2">
        <v-card flat color="white" class="pb-4">
          <v-card-text class="pa-1">
            <v-row>
              <v-col cols="7" v-if="quotationInvoiceObj != null">
                <v-row no-gutters>
                  <v-col>
                    <span class="black--text pt-1">Invoice Date:</span>
                    <flat-pickr
                      v-model="quotationInvoiceObj.issued_date"
                      class="form-control"
                      placeholder="Select Invoice Date"
                      :config="config"
                      name="date"
                    ></flat-pickr>
                  </v-col>

                  <v-col>
                    <span class="black--text pt-1">Due Date:</span>
                    <flat-pickr
                      v-model="quotationInvoiceObj.due_date"
                      class="form-control"
                      placeholder="Select Due Date"
                      :config="config"
                      name="date"
                    ></flat-pickr>
                  </v-col>

                  <v-col cols="5">
                    <span class="black--text py-1">Reference:</span>
                    <input
                      class="form-control"
                      v-model="quotationInvoiceObj.reference"
                    />
                  </v-col>
                </v-row>
              </v-col>

              <v-col v-show="invoice_type == CONSTANT.SHIPMENT_INVOICE">
                <v-row justify="end" class="pt-1">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="font-weight-bold mr-4"
                        color="secondary"
                        small
                        tile
                        @click="onGenerateFinancials"
                        >GENERATE FINANCIALS</v-btn
                      >
                    </template>
                    Transfer the financials from Estimate to actual
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="font-weight-bold ml-4"
                        color="primary"
                        small
                        tile
                        :disabled="!fc_valid || !financials_updated"
                        @click="onSaveFinancials"
                        >SAVE FINANCIALS</v-btn
                      >
                    </template>
                    Save the changes made to the financials
                  </v-tooltip>
                </v-row>
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-row justify="start" class="pb-3">
              <v-btn
                small
                tile
                outlined
                color="primary"
                class="font-weight-bold text-sm-caption px-1 mx-4"
                v-show="invoice_line_items.length > 0"
                @click="addNewComponent"
                >ADD ITEM</v-btn
              >

              <v-btn
                small
                tile
                outlined
                color="error"
                class="font-weight-bold text-sm-caption px-1"
                v-show="invoice_line_items.length > 0"
                @click="addDiscountComponent"
                >ADD DISCOUNT</v-btn
              >
            </v-row>

            <v-row no-gutters>
              <v-col v-if="invoice_line_items.length > 0">
                <quotation-invoice-table
                  v-model="invoice_line_items"
                  :quotation="quotation"
                  :editable="true"
                  :view="'NEW'"
                  v-on:updated="on_financials_updated"
                ></quotation-invoice-table>
              </v-col>

              <v-col v-else>
                <v-alert
                  tile
                  text
                  dense
                  prominent
                  border="left"
                  style="z-index: 1"
                  type="info"
                  class="my-4"
                  >Select invoice type from "Generate New Invoice"
                  dropdown.</v-alert
                >
              </v-col>
            </v-row>

            <v-row justify="start" class="pt-3">
              <v-btn
                small
                tile
                outlined
                color="primary"
                class="font-weight-bold text-sm-caption px-1 mx-4"
                v-show="invoice_line_items.length > 0"
                @click="addNewComponent"
                >ADD ITEM</v-btn
              >

              <v-btn
                small
                tile
                outlined
                color="error"
                class="font-weight-bold text-sm-caption px-1"
                v-show="invoice_line_items.length > 0"
                @click="addDiscountComponent"
                >ADD DISCOUNT</v-btn
              >
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-row justify="end">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    tile
                    small
                    color="secondary"
                    class="font-weight-bold mr-3"
                    :disabled="!is_valid"
                    @click="onCreateInvoice(CONSTANT.STATUS.INVOICE.DRAFT)"
                    >SAVE AS DRAFT</v-btn
                  >
                </template>
                Save invoice as a draft
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    tile
                    small
                    color="primary"
                    class="font-weight-bold mx-3"
                    :disabled="!is_valid"
                    @click="onCreateInvoice(CONSTANT.STATUS.INVOICE.SUBMITTED)"
                    >SAVE AS SUBMITTED</v-btn
                  >
                </template>
                Save invoice as a submitted
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    tile
                    small
                    color="success"
                    class="font-weight-bold ml-3"
                    :disabled="!is_valid"
                    @click="onCreateInvoice(CONSTANT.STATUS.INVOICE.AUTHORISED)"
                    >SAVE AS APPROVED</v-btn
                  >
                </template>
                Save invoice as authorised / approved
              </v-tooltip>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import constant from "@/const"
import flatPickr from "vue-flatpickr-component"
import QuotationInvoiceTable from "@/components/shared/QuotationInvoiceTable.vue"

export default {
  components: {
    flatPickr,
    QuotationInvoiceTable,
  },
  data() {
    return {
      CONSTANT: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      alert: false,
      alertType: "success",
      alertMessage: "",

      config: {
        altInput: true,
        altInputClass: "flatpickr-alt-input",
        // enableTime: true,
        altFormat: "M j, Y",
        dateFormat: "Y-m-d",
        // time_24hr: true,
        position: "auto",
      },

      invoice_line_items: [],

      quotation: null,
      invoice_type: null, // SHIPMENT || TAXES-DUTIES
      invoice_title: null,

      id: null,
      invoice_type_query: null,
      tax_charge_query: 0.0,
      duty_charge_query: 0.0,
      tax_duty_currency_query: null,
      query_source: null,

      dialogNotifyNotXeroSync: false,

      quotationInvoiceObj: null,

      generateInvoiceBtnItems: [
        { id: constant.SHIPMENT_INVOICE, title: "Shipment Invoice" },
        { id: constant.TAXES_DUTIES_INVOICE, title: "Taxes & Duties Invoice" },
        { id: constant.OTHER_SERVICES_INVOICE, title: "Empty Invoice" },
      ],

      financials_updated: false,

      dialogSavedInvoice: false,
      invoice_id: null,
    }
  },

  async created() {
    this.$root.fullScreenView = true
    this.id = this.$route.query.id
    this.invoice_type_query = this.$route.query.type
    this.tax_charge_query = this.$route.query.tax
    this.duty_charge_query = this.$route.query.duty
    this.tax_duty_currency_query = this.$route.query.currency
    this.query_source = this.$route.query.source

    this.$root.blockUIshow = true
    this.$root.blockUImsg = "Initialising..."

    // verify user token
    await this.$root.verify_user_token()

    // init page with quotation
    await this.getQuotation()

    // if invoice type is Taxes & Duties
    if (this.query_source == "port-shipment-task") {
      this.onSetTaxDutyLineItems()
      // if (this.invoice_type_query == constant.SHIPMENT_INVOICE) {
      //   this.generateNewInvoice(this.generateInvoiceBtnItems[0]);
      // } else if (this.invoice_type_query == constant.TAXES_DUTIES_INVOICE) {
      //   this.generateNewInvoice(this.generateInvoiceBtnItems[1]);
      // } else if (this.invoice_type_query == constant.OTHER_SERVICES_INVOICE)
      //   this.generateNewInvoice(this.generateInvoiceBtnItems[2]);
    }
  },

  mounted() {},

  watch: {},

  methods: {
    /**
     * Get the full quotation detail
     */
    getQuotation() {
      this.$root.blockUIshow = true
      this.$root.blockUImsg = "Loading quotation..."
      return new Promise(async (success, reject) => {
        let resp = await this.$https.get(`/api/quotations/${this.id}`)
        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          this.quotation = resp.data.data
          // if this Quotation Company is not synced with Xero
          // if (!this.quotation.company.xero_sync) {
          //   // notify user that this company is not synced with Xero yet
          //   this.dialogNotifyNotXeroSync = true;
          // }
        } else {
          console.log(resp.data)
          this.showSnackbar = true
          this.snackbarColor = "error"
          this.snackbarMsg = resp.data.msg
        }
        this.$root.blockUIshow = false
        success()
      })
    },

    /**
     * Sync company with Xero
     */
    // async companySyncXero() {
    //   this.$root.blockUIshow = true;
    //   this.$root.blockUImsg = "Synchronising company with Xero...";

    //   let resp = await this.$https.put(
    //     `api/company/xero/insert/${this.quotation.company.company_id}`
    //   );
    //   if (resp.data.status == constant.RESPONSE_STATUS_OK) {
    //     this.dialogNotifyNotXeroSync = false;
    //     this.showSnackbar = true;
    //     this.snackbarColor = "success";
    //     this.snackbarMsg = resp.data.msg;
    //   } else {
    //     this.showSnackbar = true;
    //     this.snackbarColor = "error";
    //     this.snackbarMsg = resp.data.msg;
    //   }
    //   this.$root.blockUIshow = false;
    // },

    /**
     * Init shipment invoice obj
     */
    onInit() {
      return new Promise((success, reject) => {
        this.$https.get(`/api/invoices/init`).then((resp) => {
          // assign pt obj
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.quotationInvoiceObj = resp.data.data
            this.quotationInvoiceObj.reference = this.id
            success()
          }
        })
      })
    },

    /**
     * Reset Invoice
     */
    async onReset() {
      // init page with quotation
      await this.getQuotation()

      this.dialogSavedInvoice = false
      this.invoice_id = null
      this.invoice_line_items = []
      this.invoice_type = null
      this.invoice_title = null
      this.$root.blockUIshow = true
      this.$root.blockUImsg = "Reseting Invoice..."

      // init invoice obj
      await this.onInit()

      this.$root.blockUIshow = false
    },

    /**
     * Add general item component to FC
     */
    addNewComponent() {
      this.invoice_line_items.push({
        type: constant.TYPE_GENERAL_ITEM,
        code: "OT-GEN",
        conversion_factor: 1.0,
        cost: {
          base: 0.0,
          min: 0.0,
          per_unit: 0.0,
          converted: 0.0,
        },
        currency: this.quotation.currency,
        description: "General item",
        price: {
          base: 0.0,
          min: 0.0,
          per_unit: 0.0,
          converted: 0.0,
        },
        quantity: 1,
        uom: "SET",
      })
    },

    /**
     * Add discount/rebate component to FC
     */
    addDiscountComponent() {
      this.invoice_line_items.push({
        type: constant.TYPE_DISCOUNT_REBATE,
        code: "OT-REB",
        conversion_factor: 1.0,
        cost: {
          base: 0.0,
          min: 0.0,
          per_unit: 0.0,
          converted: 0.0,
        },
        currency: this.quotation.currency,
        description: "Discount/rebate description",
        price: {
          base: 0.0,
          min: 0.0,
          per_unit: 0.0,
          converted: 0.0,
        },
        quantity: 1,
        uom: "SET",
      })
    },

    /**
     * on financials updated
     */
    on_financials_updated() {
      this.financials_updated = true
    },

    /**
     * Invoice title
     */
    getInvoiceTitle() {
      if (this.quotation == null) {
        return null
      }

      var quotationIDLabel =
        this.quotation.quotation_id != null
          ? this.quotation.quotation_id
          : "DRAFT"

      return `[${quotationIDLabel}] ${this.quotation.transaction_type} ${this.quotation.container_load} ${this.quotation.incoterm.incoterm} ${this.quotation.cargo_type.code} ${this.quotation.origin_port.name} to ${this.quotation.destination_port.name}`
    },

    /**
     * Generate a new invoice view
     */
    async generateNewInvoice(item) {
      this.$root.blockUIshow = true
      this.$root.blockUImsg = "Generating new invoice..."
      // init invoice obj
      await this.onInit()

      this.$root.blockUIshow = false

      switch (item.id) {
        // Shipment Invoice
        case constant.SHIPMENT_INVOICE:
          this.invoice_type = constant.SHIPMENT_INVOICE
          this.invoice_line_items = this.quotation.actual_component
          this.invoice_title = "Shipment Invoice"
          break

        // Tax & Duties Invoice
        case constant.TAXES_DUTIES_INVOICE:
          this.invoice_type = constant.TAXES_DUTIES_INVOICE
          this.onGenerateTaxesDuties()
          this.invoice_title = "Taxes & Duties Invoice"
          break

        // Other Services Invoice
        case constant.OTHER_SERVICES_INVOICE:
          this.invoice_type = constant.OTHER_SERVICES_INVOICE
          this.onGenerateOtherServicesInvoice()
          this.invoice_title = "Other Services Invoice"
          break

        default:
          break
      }
    },

    /**
     * Populate Taxes & Duties invoice object
     */
    onGenerateTaxesDuties() {
      // console.log("quotation: ", this.quotation);
      this.invoice_line_items = [
        {
          type: constant.TYPE_TAXES_DUTIES_CHARGES,
          code: "CUS-TAX",
          conversion_factor: 1.0,
          cost: {
            base: 0.0,
            min: 0.0,
            per_unit: 0.0,
            converted: 0.0,
          },
          currency: this.quotation.currency,
          description: "Sales tax, VAT, other import tax",
          price: {
            base: 0.0,
            min: 0.0,
            per_unit: 0.0,
            converted: 0.0,
          },
          quantity: 1,
          uom: "SET",
        },
        {
          type: constant.TYPE_TAXES_DUTIES_CHARGES,
          code: "CUS-DT",
          conversion_factor: 1.0,
          cost: {
            base: 0.0,
            min: 0.0,
            per_unit: 0.0,
            converted: 0.0,
          },
          currency: this.quotation.currency,
          description: "Duty Charges",
          price: {
            base: 0.0,
            min: 0.0,
            per_unit: 0.0,
            converted: 0.0,
          },
          quantity: 1,
          uom: "SET",
        },
        {
          type: constant.TYPE_TAXES_DUTIES_CHARGES,
          code: "CUS-EFT",
          conversion_factor: 1.0,
          cost: {
            base: 0.0,
            min: 0.0,
            per_unit: 0.0,
            converted: 0.0,
          },
          currency: this.quotation.currency,
          description: "Customs electronic fund transfer fee",
          price: {
            base: 0.0,
            min: 0.0,
            per_unit: 0.0,
            converted: 0.0,
          },
          quantity: 1,
          uom: "SET",
        },
      ]
    },

    /**
     * Populate Taxes & Duties invoice object
     */
    async onSetTaxDutyLineItems() {
      this.$root.blockUIshow = true
      this.$root.blockUImsg = "Generating new invoice..."
      // init invoice obj
      await this.onInit()

      this.$root.blockUIshow = false

      this.invoice_type = constant.TAXES_DUTIES_INVOICE
      this.invoice_title = "Taxes & Duties Invoice"

      this.invoice_line_items = [
        {
          type: constant.TYPE_TAXES_DUTIES_CHARGES,
          code: "CUS-TAX",
          conversion_factor: 1.0,
          cost: {
            base: 0.0,
            min: 0.0,
            per_unit: 0.0,
            converted: 0.0,
          },
          currency: this.tax_duty_currency_query,
          description: "Sales tax, VAT, other import tax",
          price: {
            base: parseFloat(this.tax_charge_query),
            min: 0.0,
            per_unit: parseFloat(this.tax_charge_query),
            converted: parseFloat(this.tax_charge_query),
          },
          quantity: 1,
          uom: "SET",
        },
        {
          type: constant.TYPE_TAXES_DUTIES_CHARGES,
          code: "CUS-DT",
          conversion_factor: 1.0,
          cost: {
            base: 0.0,
            min: 0.0,
            per_unit: 0.0,
            converted: 0.0,
          },
          currency: this.tax_duty_currency_query,
          description: "Duty Charges",
          price: {
            base: parseFloat(this.duty_charge_query),
            min: 0.0,
            per_unit: parseFloat(this.duty_charge_query),
            converted: parseFloat(this.duty_charge_query),
          },
          quantity: 1,
          uom: "SET",
        },
        {
          type: constant.TYPE_TAXES_DUTIES_CHARGES,
          code: "CUS-EFT",
          conversion_factor: 1.0,
          cost: {
            base: 0.0,
            min: 0.0,
            per_unit: 0.0,
            converted: 0.0,
          },
          currency: this.tax_duty_currency_query,
          description: "Customs electronic fund transfer fee",
          price: {
            base: 0.0,
            min: 0.0,
            per_unit: 0.0,
            converted: 0.0,
          },
          quantity: 1,
          uom: "SET",
        },
      ]
    },

    /**
     * Populate Other Services invoice object
     */
    onGenerateOtherServicesInvoice() {
      this.invoice_line_items = [
        {
          type: constant.TYPE_OTHER_SERVICES_CHARGES,
          code: "OT-GEN",
          conversion_factor: 1.0,
          cost: {
            base: 0.0,
            min: 0.0,
            per_unit: 0.0,
            converted: 0.0,
          },
          currency: this.quotation.currency,
          description: "Other charges general",
          price: {
            base: 0.0,
            min: 0.0,
            per_unit: 0.0,
            converted: 0.0,
          },
          quantity: 1,
          uom: "SET",
        },
      ]
    },

    /**
     * Transfer Estimate to Actual Financial Component
     */
    onGenerateFinancials() {
      this.$root.blockUIshow = true
      this.$root.blockUImsg = "Generating actual financials..."

      this.quotation.actual_component = this.quotation.estimate_component
      this.invoice_line_items = this.quotation.actual_component
      this.financials_updated = true
      this.showSnackbar = true
      this.snackbarColor = "success"
      this.snackbarMsg = "Financials generated successfully"
      this.$root.blockUIshow = false
    },

    /**
     * Save the Actual Financial Component of the Quotation
     */
    onSaveFinancials() {
      this.$root.blockUIshow = true
      this.$root.blockUImsg = "Saving financials.."

      this.$https
        .put(
          `/api/quotations/actual_component/${this.quotation.quotation_id}`,
          this.af_line_items
        )
        .then((resp) => {
          var response = resp.data
          if (
            response != null &&
            response.status == constant.RESPONSE_STATUS_OK
          ) {
            this.financials_updated = false

            this.showSnackbar = true
            this.snackbarColor = "success"
            this.snackbarMsg = response.msg
          } else {
            console.log("Error saving quotation", response)
            this.showSnackbar = true
            this.snackbarColor = "error"
            this.snackbarMsg = response.msg
          }
          this.$root.blockUIshow = false
        })
        .catch((err) => {
          console.log(err)
          this.showSnackbar = true
          this.snackbarColor = "error"
          this.snackbarMsg = err
          this.$root.blockUIshow = false
        })
    },

    /**
     * On create a new Invoice
     */
    async onCreateInvoice(status) {
      this.$root.blockUIshow = true
      this.$root.blockUImsg = "Creating invoice..."

      this.quotationInvoiceObj.af_line_items = this.af_line_items

      // tag invoice
      if (this.invoice_type == constant.SHIPMENT_INVOICE) {
        this.quotationInvoiceObj.tags = ["shipment"]
        this.quotationInvoiceObj.invoice_type = this.invoice_type
      } else if (this.invoice_type == constant.TAXES_DUTIES_INVOICE) {
        this.quotationInvoiceObj.tags = ["taxes-duties"]
        this.quotationInvoiceObj.invoice_type = this.invoice_type
      } else if (this.invoice_type == constant.OTHER_SERVICES_INVOICE) {
        this.quotationInvoiceObj.tags = ["other-services"]
        this.quotationInvoiceObj.invoice_type = this.invoice_type
      } else {
        this.quotationInvoiceObj.tags = []
        this.quotationInvoiceObj.invoice_type = null
      }

      // validate date
      if (
        this.quotationInvoiceObj.issued_date == null ||
        this.quotationInvoiceObj.due_date == null
      ) {
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = "Invalid Issued Date or Due Date"
        this.$root.blockUIshow = false
        return
      }

      // update the invoice status
      this.quotationInvoiceObj.status = status

      try {
        let resp = await this.$https.post(
          `/api/quotations/${this.id}/invoices`,
          this.quotationInvoiceObj
        )
        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          this.invoice_id = resp.data.invoice_id
          // open success save dialog
          this.dialogSavedInvoice = true
        } else {
          console.log(resp.data)
          this.showSnackbar = true
          this.snackbarColor = "error"
          this.snackbarTimeout = 10000
          this.snackbarMsg = resp.data.msg
        }
      } catch (error) {
        console.log(error)
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = error
      }
      this.$root.blockUIshow = false
    },

    /**
     * Navigate to the Invoice page
     */
    goToInvoicePage() {
      // redirect user to the invoice
      this.$router.replace({
        name: "invoices",
      })
    },
  },
  computed: {
    quotation_actual_component: {
      get() {
        if (this.quotation == null) {
          return []
        }
        // return the actual component
        return this.quotation.actual_component
      },
    },

    af_line_items: {
      get() {
        if (
          this.invoice_line_items == null ||
          this.invoice_line_items.length == 0
        ) {
          return []
        }
        // return the invoice line items
        return this.invoice_line_items
      },
    },

    fc_valid: {
      get() {
        return (
          this.quotation_actual_component != null &&
          this.quotation_actual_component.length > 0
        )
      },
    },
    is_valid: {
      get() {
        return this.af_line_items != null && this.af_line_items.length > 0
      },
    },
  },
}
</script>

<style>
.v-expansion-panel {
  margin-bottom: 0px;
  border: 1px dotted gainsboro;
}

.quotation-invoice-container {
  border: 1px solid grey;
  padding: 15px 15px;
}

.v-btn.square {
  border-radius: 0px;
  background-color: #007bff;
}

.v-btn.square.v-btn--disabled {
  border-radius: 0px;
  background-color: grey;
}
</style>
